import React, { Fragment, useEffect, useState, useCallback } from "react";
import { Route } from "react-router-dom";
import Toolbar from "../Menu/Toolbar/toolbar";
import SideDrawer from "../Menu/SideDrawer/sideDrawer";
import BackDrop from "../Menu/Backdrop/backDrop";
import { useSelector, useDispatch } from "react-redux";
import { reset } from "../../redux/actions/fetch/fetchActions";
import { updateState } from "../../redux/actions/refreshInspection/refreshInspectionActions";
import { updateState as updateStateDirect } from '../../redux/actions/directInspection/directInspectionAction';
import { updateStateArrivalDepature } from '../../redux/actions/refreshArrivalDepature/refreshArrivalDepatureAction';
import Settlements from "../Pages/Settlements/Settlements";

import App from "../../App";
import Home from "../Pages/Home/home";
import Loads from "../Pages/Loads/loads";
import Settings from "../Pages/Settings/settings";
import Messages from "../Pages/Messages/Messages";
import Profile from '../Pages/Profile/Profile';
import Assistance from "../Pages/Assistance/Assistance";

import { Backdrop, CircularProgress } from "@material-ui/core";

import * as signalR from "@aspnet/signalr";

//Hooks
import useFetch from "../../hooks/useFetch";

// Utils de las notificaciones`
import {
  notificarme,
  GenerarSubcripcion,
  enviarSubscripcion,
  cancelarSubcripcionLogout,
} from "../../utils/Notificaciones";

import Axios from "axios";
import DB from "../../db";

import DialogNotification from "../DialogNotification/DialogNotification";
import DialogMultipleSession from "../DialogMultipleSession/DialogMultipleSession";
import config from "../../config";

export default function Main(props) {
  const { token, debug, label, email, name, idDriver, authKey } = props;

  const [dataNotification, setDataNotification] = useState({
    msg: "",
    type: "",
    open: false,
    onlyOkButton: false,
    data: null
  });
  const [multipleSessionDialog, setMultipleSessionDialog] = useState(false);
  const [notificacionesVistas, setNotificacionesVistas] = useState([]);
  const [isNotificationRequire, setIsNotificationRequire] = useState(false);
  const [setting, setSetting] = useState({
    chequeando: 0,
    conectando: 0,
    mensaje: localStorage.getItem("mensaje"),
    debug: debug,
    intevalo: 1, //30 seconds
    recargar: false,
    salir: false,
    sideDrawerOpen: false,
    home: label === "home" ? true : false,
    today: label === "today" ? true : false,
    yesterday: label === "yesterday" ? true : false,
    tomorrow: label === "tomorrow" ? true : false,
    messages: label === "messages" ? true : false,
    settings: label === "settings" ? true : false,
    settlements: label === "settlements" ? true : false,
    profile: label === "profile" ? true : false,
    assistance: label === "assistance" ? true : false,
    today_badge: 0,
    tomorrow_badge: 0,
    yesterday_badge: 0,
    messages_badge: 0,
    label: label,
    token: token,
    email: email,
    name: name,
    idDriver: idDriver,
    language: localStorage.getItem("language"),
    focus: false,
    online: false,
    sonido: localStorage.getItem("sound"),
    server: config.API_URL,
    platform: localStorage.getItem("platform"),
    os_version: localStorage.getItem("os_version"),
    width: localStorage.getItem("width"),
    height: localStorage.getItem("height") - 70,
  });

  const data = useFetch(
    `${config.API_URL}services/app/Trip/GetTripsByDriver?idDriver=${idDriver}&key=${authKey}`,
    setNotificacionesVistas,
    setMultipleSessionDialog
  );

  const fetch = useSelector((state) => state.fetch);
  const dispatch = useDispatch();
  const db = new DB();

  useEffect(() => {
    localStorage.setItem("label", label);
  }, []);

  useEffect(() => {
    if (fetch.refreshData) {
      data.doFetch();
    }
  }, [fetch.refreshData]);

  useEffect(() => {
    if (fetch.error) {
      console.log(fetch.error)
      if (fetch.error === 'Unauthorized') {
        setMultipleSessionDialog(true);
      }
    }
  }, [fetch.error]);

  useEffect(() => {
    if (notificacionesVistas.length > 0) {
      if (data.notificaciones != null) {
        setDataNotification({
          ...dataNotification,
          msg: data.notificaciones.cuerpo,
          url: data.notificaciones.cuerpo,
          open: true,
        });
      }
    }
  }, [notificacionesVistas]);

  useEffect(() => {
    if (data.error) {
      if (data.error === "Multiple session error") {
        setMultipleSessionDialog(true);
      }
    }
  }, [data.error]);


  const MultipleSessionOk = async () => {
    setMultipleSessionDialog(false);
    db.deleteAll().then((result) => {
      localStorage.setItem("token", "");
      localStorage.setItem("email", "");
      localStorage.setItem("name", "");
      localStorage.setItem("sound", true);
      localStorage.setItem("platform", "");
      localStorage.setItem("os_version", "");
      localStorage.setItem("width", "");
      localStorage.setItem("height", "");
      localStorage.setItem("push", "");
      localStorage.setItem("STEP", 0);
      localStorage.setItem("carrier_address", "");
      localStorage.setItem("carrier_name", "");
      localStorage.setItem("signature", "");
      localStorage.setItem("user_phone", "");
      localStorage.setItem("orden", 0);
      localStorage.setItem("label", "");
      cancelarSubcripcionLogout();
      dispatch(reset());
      setSetting({
        ...setting,
        token: "",
        salir: true,
      });
      window.location.reload();
    });
  };

  const NotificationOk = async () => {

    await SendNotificationSee();

    if (setting.label === "today") {
      setSetting({
        ...setting,
        today_badge: 0,
        tomorrow_badge: data.badge.tomorrow_badge,
        yesterday_badge: data.badge.yesterday_badge,
      });
    } else if (setting.label === "tomorrow") {
      setSetting({
        ...setting,
        today_badge: data.badge.today_badge,
        tomorrow_badge: 0,
        yesterday_badge: data.badge.yesterday_badge,
      });
    } else if (setting.label === "yesterday") {
      setSetting({
        ...setting,
        today_badge: data.badge.today_badge,
        tomorrow_badge: data.badge.tomorrow_badge,
        yesterday_badge: 0,
      });
    } else {
      setSetting({
        ...setting,
        today_badge: data.badge.today_badge,
        tomorrow_badge: data.badge.tomorrow_badge,
        yesterday_badge: data.badge.yesterday_badge,
      });
    }

    setDataNotification({
      msg: "",
      type: "",
      open: false,
      onlyOkButton: false,
      data: null
    });
  };

  const NotificationVer = async () => {
    if (dataNotification.type === "INSPECTION") {
      setSetting({
        ...setting,
        today: false,
        home: false,
        yesterday: false,
        tomorrow: false,
        messages: false,
        settings: false,
        settlements: true,
        label: "settlements",
      });
      localStorage.setItem("label", "settlements");
    } else {
      await SendNotificationSee();

      setSetting({
        ...setting,
        today: true,
        home: false,
        yesterday: false,
        tomorrow: false,
        messages: false,
        settings: false,
        label: "today",
        today_badge: 0,
        tomorrow_badge: data.badge.tomorrow_badge,
        yesterday_badge: data.badge.yesterday_badge,
      });
    }
    setDataNotification({
      msg: "",
      type: "",
      open: false,
      onlyOkButton: false,
      data: null
    });
  };

  const SendNotificationSee = async () => {
    if (notificacionesVistas.length > 0) {
      var url = `${config.API_URL}services/app/Trip/MarkTripAsSeen?idDriver=${idDriver}&key=${authKey}`;

      const response = await Axios.post(url, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Abp.Tenantid": config.TENANT_ID,
        },
      });

      if (response.data.result.status === true) {
        setNotificacionesVistas([]);
      } else {
        if (response.data.result.message === "Unauthorized") {
          setMultipleSessionDialog(true);
        }
      }
    }
  };

  useEffect(() => {
    notificarme(setIsNotificationRequire);
    if (navigator.onLine) {
      onOnline();
    } else {
      onOffline();
    }
    //onFocus();
  }, []);

  const onOnline = () => {
    setSetting({
      ...setting,
      online: true,
    });
  };

  const onOffline = () => { };

  const onCloseNotification = () => {
    setDataNotification({
      ...dataNotification,
      open: false,
    });
  };

  window.addEventListener("online", onOnline);
  window.addEventListener("offline", onOffline);


  const messageNotificacion = useCallback((event) => {
    if (event.data.type == "REJECTED_TRIP_NOTIFICATION") {
      setDataNotification({
        ...dataNotification,
        msg: event.data.body,
        url: event.data.body,
        type: "REJECTED_TRIP_NOTIFICATION",
        open: true,
      });
    }
    data.doFetch();
  }, []);

  navigator.serviceWorker.addEventListener("message", messageNotificacion);

  useEffect(() => {
    if (isNotificationRequire) {
      GenerarSubcripcion().then((result) => {
        enviarSubscripcion(result);
      });
    }
  }, [isNotificationRequire]);

  const drawerToggleClickHandler = () => {
    setSetting({
      ...setting,
      sideDrawerOpen: !setting.sideDrawerOpen,
    });
  };

  const backdropClickHandler = (e) => {
    setSetting({
      ...setting,
      sideDrawerOpen: false,
    });
  };

  const drawerClickHandler = async (e) => {
    var opcion = e.currentTarget.getAttribute("data-column");
    switch (opcion) {
      case "en":
        localStorage.setItem("language", "es");
        setSetting({
          ...setting,
          language: "es",
          sideDrawerOpen: false,
        });

        break;
      case "es":
        localStorage.setItem("language", "en");
        setSetting({
          ...setting,
          language: "en",
          sideDrawerOpen: false,
        });
        break;
      case "logout":
        db.deleteAll().then((result) => {
          localStorage.setItem("token", "");
          localStorage.setItem("email", "");
          localStorage.setItem("name", "");
          localStorage.setItem("sound", true);
          localStorage.setItem("platform", "");
          localStorage.setItem("os_version", "");
          localStorage.setItem("width", "");
          localStorage.setItem("height", "");
          localStorage.setItem("push", "");
          localStorage.setItem("STEP", 0);
          localStorage.setItem("carrier_address", "");
          localStorage.setItem("carrier_name", "");
          localStorage.setItem("signature", "");
          localStorage.setItem("user_phone", "");
          localStorage.setItem("orden", 0);
          localStorage.setItem("label", "");
          localStorage.setItem("arrival_depature", "");
          localStorage.setItem("user_id", "");
          cancelarSubcripcionLogout();
          dispatch(reset());
          setSetting({
            ...setting,
            token: "",
            salir: true,
          });
          window.location.reload();
        });
        break;
      case "home":
        deselecciono();
        setSetting({
          ...setting,
          home: true,
          today: false,
          yesterday: false,
          tomorrow: false,
          messages: false,
          settings: false,
          settlements: false,
          label: opcion,
          sideDrawerOpen: false,
          assistance: false,
          profile: false
        });
        localStorage.setItem("STEP", 0);
        localStorage.setItem("label", "home");
        break;
      case "today":
        deselecciono();
        setSetting({
          ...setting,
          today: true,
          home: false,
          yesterday: false,
          tomorrow: false,
          messages: false,
          settings: false,
          label: opcion,
          sideDrawerOpen: false,
          settlements: false,
          today_badge: 0,
          profile: false,
          assistance: false,
        });
        localStorage.setItem("STEP", 0);
        localStorage.setItem("label", "today");
        break;
      case "yesterday":
        deselecciono();
        setSetting({
          ...setting,
          yesterday: true,
          home: false,
          today: false,
          tomorrow: false,
          messages: false,
          settings: false,
          label: opcion,
          sideDrawerOpen: false,
          settlements: false,
          yesterday_badge: 0,
          profile: false,
          assistance: false,
        });
        localStorage.setItem("STEP", 0);
        localStorage.setItem("label", "yesterday");
        break;
      case "tomorrow":
        deselecciono();
        setSetting({
          ...setting,
          tomorrow: true,
          home: false,
          today: false,
          yesterday: false,
          messages: false,
          settings: false,
          label: opcion,
          sideDrawerOpen: false,
          settlements: false,
          tomorrow_badge: 0,
          profile: false,
          assistance: false,
        });
        localStorage.setItem("STEP", 0);
        localStorage.setItem("label", "tomorrow");
        break;
      case "messages":
        deselecciono();
        setSetting({
          ...setting,
          messages: true,
          home: false,
          today: false,
          yesterday: false,
          tomorrow: false,
          settings: false,
          label: opcion,
          sideDrawerOpen: false,
          settlements: false,
          messages_badge: 0,
          profile: false,
          assistance: false,
        });
        localStorage.setItem("STEP", 0);
        localStorage.setItem("label", "message");
        break;
      case "settlements":
        deselecciono();
        setSetting({
          ...setting,
          messages: false,
          home: false,
          today: false,
          yesterday: false,
          tomorrow: false,
          settings: false,
          label: opcion,
          sideDrawerOpen: false,
          settlements: true,
          profile: false,
          assistance: false,
        });
        localStorage.setItem("STEP", 0);
        localStorage.setItem("label", "settlements");
        break;
      case "settings":
        deselecciono();
        setSetting({
          ...setting,
          settings: true,
          home: false,
          today: false,
          yesterday: false,
          tomorrow: false,
          messages: false,
          label: opcion,
          settlements: false,
          sideDrawerOpen: false,
          profile: false,
          assistance: false,
        });
        localStorage.setItem("STEP", 0);
        localStorage.setItem("label", "settings");
        break;
      case "profile":
        deselecciono();
        setSetting({
          ...setting,
          profile: true,
          settings: false,
          home: false,
          today: false,
          yesterday: false,
          tomorrow: false,
          messages: false,
          label: opcion,
          settlements: false,
          sideDrawerOpen: false,
          assistance: false,
        });
        localStorage.setItem("STEP", 0);
        localStorage.setItem("label", "");
        break;
      case "assistance":
        deselecciono();
        setSetting({
          ...setting,
          profile: false,
          settings: false,
          home: false,
          today: false,
          yesterday: false,
          tomorrow: false,
          messages: false,
          label: opcion,
          settlements: false,
          sideDrawerOpen: false,
          assistance: true,
        });
        localStorage.setItem("STEP", 0);
        localStorage.setItem("label", "");
        break;
      default:
      //nothing...
    }
  };

  //----------------------------------------------------------------
  const messagesClickHandler = (e) => {
    deselecciono();
    setSetting({
      ...setting,
      messages: true,
      home: false,
      today: false,
      yesterday: false,
      tomorrow: false,
      settings: false,
      label: "messages",
      messages_badge: 0,
    });
  };

  const profileHandleClick = () => {
    setSetting({
      ...setting,
      label: "profile"
    })
  }

  const deselecciono = () => {
    setSetting({
      ...setting,
      home: false,
      today: false,
      yesterday: false,
      tomorrow: false,
      messages: false,
      settings: false,
      profile: false,
      assistance: false
    });
  };

  let backdrop;
  if (setting.sideDrawerOpen) {
    backdrop = <BackDrop click={backdropClickHandler} />;
  }

  if (setting.salir) {
    return (
      <Fragment>
        <div className='container-fluid'>
          <Route path='/' render={(props) => <App {...props} />} />
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <div style={{ height: "100%", width: "100%" }}>
        <DialogNotification
          open={dataNotification.open}
          onClose={onCloseNotification}
          cuerpo={dataNotification.msg}
          handleOk={NotificationOk}
          handleVer={NotificationVer}
          onlyOkButton={dataNotification.onlyOkButton}
        />
        <DialogMultipleSession
          open={multipleSessionDialog}
          handleOk={MultipleSessionOk}
        />
        <Toolbar
          label={setting.label}
          online={setting.online}
          drawerClickHandler={drawerToggleClickHandler}
          messages_badge={setting.messages_badge}
          messagesClickHandler={messagesClickHandler}
        />
        <SideDrawer
          label={setting.label}
          show={setting.sideDrawerOpen}
          click={drawerClickHandler}
          today_badge={setting.today_badge}
          tomorrow_badge={setting.tomorrow_badge}
          yesterday_badge={setting.yesterday_badge}
          messages_badge={setting.messages_badge}
          profileHandleClick={profileHandleClick}
        />
        {backdrop}

        <div
          style={{
            position: "relative",
            left: "0px",
            marginTop: "65px",
            marginLeft: "0px",
            marginRight: "0px",
            marginBottom: "10px",
            overflowY: "auto",
          }}
        >
          {setting.debug && (
            <span
              style={{
                position: "fixed",
                background: "red",
                zIndex: "200",
              }}
            ></span>
          )}
          {data.isloading ? (
            <Backdrop open={data.isloading}>
              <CircularProgress color='inherit' />
            </Backdrop>
          ) : (
            <div>
              {setting.home ? (
                <Home
                  language={localStorage.getItem("language")} />
              ) : setting.today ? (
                <Loads data={data.todayData} step={0} />
              ) : setting.yesterday ? (
                <Loads data={data.yesterdayData} step={0} />
              ) : setting.tomorrow ? (
                <Loads data={data.tomorrowData} step={0} />
              ) : setting.messages ? (
                <Messages />
              ) : setting.settlements ? (
                <Settlements authKey={authKey} idDriver={idDriver} />
              ) : setting.profile ? (
                <Profile />
              ) : setting.assistance ? (
                <Assistance language={localStorage.getItem("language")} />
              ) : (
                setting.settings && (
                  <Settings
                    language={localStorage.getItem("language")}
                    ancho={setting.width}
                    alto={setting.height}
                  />
                )
              )}
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
}
